import { useQuery } from '@tanstack/react-query';
import { ConnectionsApi, type Connections } from 'osep-auth-service-client-v1';
import { useApiConfig } from '../useApiConfig';
import {
  CONNECTIONS_POLL_INTERVAL_MS,
  CONNECTIONS_QUERY_KEY,
} from '../../utils/consts';

export const useConnectionsQuery = () => {
  const { getAuthApiConfig, getUserId, axiosInstance } = useApiConfig();
  const userId = getUserId();

  return useQuery({
    queryKey: [CONNECTIONS_QUERY_KEY, userId],
    queryFn: async (): Promise<Connections> => {
      const api = new ConnectionsApi(
        await getAuthApiConfig(),
        undefined,
        axiosInstance,
      );
      const response = await api.listConnections();
      return response.data;
    },
    enabled: !!userId,
    refetchInterval: CONNECTIONS_POLL_INTERVAL_MS,
    refetchOnWindowFocus: 'always',
  });
};
